"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Routes_1 = require("../enum/Routes");
var UrlParamTypes_1 = require("../enum/UrlParamTypes");
var usePlatformConfig_1 = require("../react/usePlatformConfig");
var useUrlSearchParams_1 = require("./useUrlSearchParams");
var useCheckoutContext_1 = require("../../gql/common/hooks/useCheckoutContext");
var useRedirect = function () {
    var searchParams = useUrlSearchParams_1.default();
    var _a = react_1.useState(null), redirecProps = _a[0], setRedirectProps = _a[1];
    var _b = usePlatformConfig_1.default().platformConfig.platformFeatures, isDealerEnabled = _b.isDealerEnabled, isExtrasPageEnabled = _b.isExtrasPageEnabled;
    var extrasPageHasContent = useCheckoutContext_1.default().extrasPageHasContent;
    var getRedirectPath = react_1.useCallback(function () {
        if (isExtrasPageEnabled && extrasPageHasContent) {
            return Routes_1.Routes.EXTRAS;
        }
        if (isDealerEnabled) {
            return Routes_1.Routes.DEALER;
        }
        return Routes_1.Routes.REQUEST_QUOTE;
    }, [isDealerEnabled, isExtrasPageEnabled, extrasPageHasContent]);
    react_1.useEffect(function () {
        var _a = searchParams || {}, token = _a.token, from = _a.from;
        var queryString = UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token + "&" + UrlParamTypes_1.UrlParamTypes.FROM + "=" + from;
        if (token && extrasPageHasContent !== null) {
            setRedirectProps({
                to: {
                    pathname: getRedirectPath(),
                    search: queryString,
                },
                from: Routes_1.Routes.INDEX,
                exact: true,
            });
        }
    }, [searchParams, extrasPageHasContent, getRedirectPath]);
    return redirecProps;
};
exports.default = useRedirect;
